import "./PatientInfoView.scss";

const WEIGHT_UNITS = { 1: "kg", 2: "pound" };
const HEIGHT_UNITS = { 1: "feet", 2: "cm" };

const InfoField = ({ label, value }) => (
  <div className="info-field">
    <span className="info-field_label">{label}</span>
    <span className="info-field_value">{value || "-"}</span>
  </div>
);

// Read-only summary of a patient's profile — the landing view before the
// user opts into PatientFormFields via the "Edit" button. Acquisition
// Settings now live in their own tab (see AcquisitionSettingsInfo).
const PatientInfoView = ({ formData, gender }) => {
  const genderLabel = gender.find(
    (option) => String(option.value) === String(formData.genderId)
  )?.label;
  const weightUnit = WEIGHT_UNITS[Number(formData.weightMeasurementType)] || "kg";
  const heightUnit = HEIGHT_UNITS[Number(formData.heightMeasurementType)] || "feet";

  return (
    <div className="patient-info-grid">
      <InfoField label="Name" value={formData.name} />
      <InfoField label="User Name" value={formData.userName} />
      <InfoField label="Device ID" value={formData.deviceName || "No device assigned"} />
      <InfoField label="Gender" value={genderLabel} />
      <InfoField label="Date of Birth" value={formData.dateOfBirth} />
      <InfoField label="Weight" value={formData.weight ? `${formData.weight} ${weightUnit}` : ""} />
      <InfoField label="Height" value={formData.height ? `${formData.height} ${heightUnit}` : ""} />
      <InfoField label="Mobile Number" value={formData.mobileNumber} />
      <InfoField label="Email ID" value={formData.email} />
    </div>
  );
};

export default PatientInfoView;
